export default {
  toasts: {
    failed_to_delete_website: 'Eliminazione sito web non riuscita',
    website_deleted: 'Sito web eliminato',
  },
  delete_model: {
    title: 'Sei sicuro di voler eliminare il sito web?',
    confirm: 'Elimina',
    cancel: 'Annulla',
  },
  buttons: {
    open_editor: 'Apri editor',
    transfer_website: 'Trasferisci sito web',
    delete_site: 'Elimina',
  },
};
